<template>
  <div id="about">
    <div id="close-button-fixed">
      <img
        @click="$router.push({ path: '/' })"
        id="close-button"
        src="../assets/close_button.png"
        alt="close impressum"
      />
    </div>

    <h1 id="about-title">ECCHR Explore</h1>

    <h1>Imprint</h1>

    <h3>
      Responsible for the <br />
      content of this website
    </h3>

    <div class="text-box-small">
      European Center for Constitutional <br />
      and Human Rights e.V. <br />
      Chairwoman: Lotte Leicht <br />
      Zossener Str. 55–58 <br />
      10961 Berlin, Germany
    </div>

    <div class="text-box-small">
      Phone: +49 30 400 485 90 <br />
      Telefax: +49 30 400 485 92 <br />
      info@ecchr.eu
    </div>

    <div class="text-box-small">
      Register Court: Amtsgericht Charlottenburg <br />
      Register no.: VR 26608 <br />
      Tax Identification: 27/664/51478
    </div>

    <h3>
      Data protection officer <br />
      of ECCHR
    </h3>

    <div class="text-box-small">
      Dieter Hummel <br />
      dataprotectionofficer@ecchr.eu
    </div>

    <div class="hoirzontal-separator"></div>

    <h1>Privacy policy</h1>

    <div class="text-box">
      With ECCHR Explore, ECCHR offers you a special platform for media content.
      When you use the ECCHR Explore App, you will be redirected to the
      metasphere server – ecchr.metasphere.xyz – which we use for this offer.
      For this purpose, ECCHR collects and uses data on ECCHR Explore that may
      allow identification. These are: IP address of the requesting computer,
      date and time of the request, desired access method, name of the requested
      file, URL of the requesting device (from which the file was requested or
      the desired action was initiated). After the end of the visit to ECCHR
      Explore, the IP address will be deleted immediately and no personal data
      will be saved. An evaluation does not take place.
      <br />
      <br />
      ECCHR Explore does not set any cookies.
      <br />
      <br />
      ECCHR Explore also refers to so-called hyperlinks – i.e. links to websites
      from other providers. If you click on these links, you will be redirected
      directly to the websites of the other providers. You can recognize this by
      the change in the URL, among other things. We cannot assume any
      responsibility for the confidential handling of your data, as we have no
      influence on whether these companies comply with data protection
      regulations. Please refer to their websites for information about how
      these companies handle your personal data.
    </div>

    <h3>
      Responsible body for <br />
      data processing
    </h3>

    <div class="text-box-small">
      European Center for Constitutional <br />
      and Human Rights e.V. <br />
      Zossener Str. 55–58 <br />
      10961 Berlin, Germany
    </div>

    <div class="text-box-small">
      Phone: +49 30 400 485 90 <br />
      Telefax: +49 30 400 485 92 <br />
      info@ecchr.eu
    </div>

    <h3>
      Data protection officer <br />
      of ECCHR
    </h3>

    <div class="text-box-small">
      Dieter Hummel <br />
      dataprotectionofficer@ecchr.eu
    </div>

    <h3>
      This is a translated version of our privacy policy in german language. In
      case of doubt, the german version (available below) is authoritative.
    </h3>

    <div class="hoirzontal-separator"></div>

    <h1>Datenschutz-erklärung</h1>

    <div class="text-box">
      Das ECCHR bietet Ihnen mit ECCHR Explore eine besondere Plattform für
      Medieninhalte an. Mit der Nutzung der ECCHR Explore App werden Sie auf den
      Server von metasphere – ecchr.metasphere.xyz – weitergeleitet, den wir für
      dieses Angebot nutzen. ECCHR erhebt und nutzt dazu auf ECCHR Explore
      Daten, die möglicherweise eine Identifizierung zulassen. Dies sind:
      IP-Adresse des anfordernden Rechners, Datum und Uhrzeit der Anforderung,
      gewünschte Zugriffsmethode, Name der angeforderten Datei, URL des
      anfragenden Endgeräts (von der aus die Datei angefordert wurde oder die
      gewünschte Aktion veranlasst wurde). Nach dem Ende des Besuchs bei ECCHR
      Explore wird die IP-Adresse sofort gelöscht und bleiben keine
      personenbezogenen Daten gespeichert. Eine Auswertung findet nicht statt.
      <br />
      <br />
      ECCHR Explore setzt keine Cookies.
      <br />
      <br />
      ECCHR Explore verweist auch auf sogenannte Hyperlinks – also Links zur
      Webseite von anderen Anbietern. Wenn Sie auf diese Links klicken, werden
      Sie direkt auf die Webseite der anderen Anbieter weitergeleitet. Dies
      erkennen Sie unter anderem am Wechsel der URL. Wir können keine
      Verantwortung für den vertraulichen Umgang Ihrer Daten übernehmen, da wir
      keinen Einfluss darauf haben, dass diese Unternehmen die
      Datenschutz-bestimmungen einhalten. Über den Umgang mit Ihren
      personenbezogenen Daten durch diese Unternehmen informieren Sie sich bitte
      auf deren Websites direkt.
    </div>

    <h3>
      Verantwortliche Stelle für die <br />
      Datenverarbeitung ist das
    </h3>

    <div class="text-box-small">
      European Center for Constitutional <br />
      and Human Rights e.V. <br />
      Zossener Str. 55–58 <br />
      10961 Berlin, Germany
    </div>

    <div class="text-box-small">
      Phone: +49 30 400 485 90 <br />
      Telefax: +49 30 400 485 92 <br />
      info@ecchr.eu
    </div>

    <h3>
      Datenschutzbeauftragter <br />
      des ECCHR ist
    </h3>

    <div class="text-box-small">
      Dieter Hummel <br />
      dataprotectionofficer@ecchr.eu
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
#about {
  display: relative;
  margin-top: 10px;
  margin-bottom: 30px;
  margin-left: 38px;
  overflow-y: scroll;
  padding-right: 20px;
}

#about-title {
  width: 190px;
  padding-bottom: 30px;
}

#close-button {
  width: 32px;
  position: sticky;
  padding-top: 20px;
  padding-right: 20px;
  top: 0px;
  left: 90%;
}

#close-button-fixed {
  position: absolute;
  right: 0px;
  left: 0px;
  width: 375px;
  z-index: 1;
}

h1 {
  margin-top: 40px;
  font-size: 28px;
  margin-bottom: 35px;
  padding-right: 35px;
}

h2 {
  font-size: 16px;
  font-weight: 500;
  width: 240px;
}

h3 {
  padding-top: 20px;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  width: 240px;
}

h4 {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 4px;
}
.text {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: left;
  color: rgba(235, 235, 245, 0.6);
  padding-right: 35px;
}

.text-box {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0px;
  text-align: left;
  color: rgba(235, 235, 245, 0.6);
  padding-right: 35px;
}

.text-box-small {
  padding-bottom: 20px;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0px;
  text-align: left;
  color: rgba(235, 235, 245, 0.6);
  padding-right: 35px;
}

.hoirzontal-separator {
  margin: 40px 25px 20px 0px;
  width: inherit;
  border: 1px solid rgba(58, 58, 60);
}
</style>